/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-11-28 14:52:20
 * @LastEditors: susj
 * @LastEditTime: 2020-11-28 14:53:12
 */
import Vue from 'vue';
import SvgIcon from '@/components/svgIcon/Index.vue';

Vue.component('svg-icon', SvgIcon);
